
import {getProductByID, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function CurversBlindsPage() {

  return (
      GenericProductPage(getProductByID(43),toBlind)
  )
}
